import { render, staticRenderFns } from "./RecordStatusTypesSelect.vue?vue&type=template&id=039aa24f&scoped=true&lang=pug"
import script from "./RecordStatusTypesSelect.vue?vue&type=script&lang=js"
export * from "./RecordStatusTypesSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039aa24f",
  null
  
)

export default component.exports